export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9160.b9489482.jpg";